'use client'
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/client.ts
import { GraphQLClient } from "graphql-request";
import { Exception } from "@wbk/logger";

// src/config.ts
var ContentfulApiConfig = class {
  constructor() {
    this._config = null;
  }
  get config() {
    return this._config;
  }
  init(config) {
    this._config = this.setConfig(config);
    this.configClient(this._config);
  }
  update(config) {
    this._config = this.setConfig(config);
    this.configClient(this._config);
  }
  /**
   * Set the config object with defaults
   */
  setConfig(config) {
    return __spreadProps(__spreadValues(__spreadValues({}, this._config), config), {
      supportLocales: config.supportLocales || ["en", "ar"]
    });
  }
  configClient(config) {
    gqlClient.setEndpoint(config.base);
    gqlClient.requestConfig.method = "POST";
  }
};
var ContentfulConfig = new ContentfulApiConfig();

// src/api/client.ts
var gqlClient = new GraphQLClient("");
gqlClient.requestConfig.requestMiddleware = (req) => {
  if (!ContentfulConfig.config) {
    const msg = "WBK `ContentfulConfig` was not initialized. See instructions in https://github.com/nadude/webook-frontend/blob/main/packages/contentful/README.md";
    throw new Error(msg);
  }
  return req;
};
var requestWithRateLimitHandling = (query, variables) => __async(void 0, null, function* () {
  var _a, _b, _c, _d, _e, _f;
  try {
    const response = yield gqlClient.request(query, variables);
    return response;
  } catch (error) {
    const graphqlError = error;
    const isRateLimitError = (_b = (_a = graphqlError == null ? void 0 : graphqlError.response) == null ? void 0 : _a.errors) == null ? void 0 : _b.some((e) => {
      var _a2;
      const contentful = (_a2 = e == null ? void 0 : e.extensions) == null ? void 0 : _a2.contentful;
      return (contentful == null ? void 0 : contentful.code) === "RATE_LIMIT_EXCEEDED";
    });
    if (isRateLimitError) {
      const queryName = (_f = (_e = (_d = (_c = query == null ? void 0 : query.split("(")) == null ? void 0 : _c[0]) == null ? void 0 : _d.split(" ")) == null ? void 0 : _e[1]) != null ? _f : "Unknown Query";
      new Exception({
        error: new Error("Rate limit exceeded"),
        name: queryName,
        context: {
          extra: { query, variables }
        }
      });
      return { rateLimited: true };
    }
    throw error;
  }
});

export {
  gqlClient,
  requestWithRateLimitHandling,
  ContentfulConfig
};
//# sourceMappingURL=chunk-DZ54PK2S.mjs.map